<template>
  <span>
    <span class="ft-12"
      >商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link></span
    >
    <GroupImagesList :baseItemId="tbFormVm.form.baseItemId" :hideImgs="['detailImages']" :specifications="specifications" @useOk="useGroupImages" @getList="getGroupImagesList"></GroupImagesList>
  </span>
</template>

<script>
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue';
import storeMixins from '../store-mixins';

export default {
  components: {
    GroupImagesList,
  },
  inject: ['tbFormVm'],
  mixins: [storeMixins],
  props: ['props'],
  computed: {
    key() {
      return this.props.name;
    },
    specifications() {
      return this.tbFormVm?.$refs?.form?.$refs?.saleProp?.length && this.tbFormVm?.$refs?.form?.$refs?.saleProp[0]?.specifications;
    },
  },
  methods: {
    useGroupImages(data, type) {
      const { mainImages = [], speImages = [] } = data;
      const groupMainImages34 = data?.mainImages34 || []
      let pic = [], mainImages34= [];
      if (type === 'add') {
        pic = [...this.tbForm.images].filter(Boolean);
        mainImages34 = [...this.tbForm.threeToFourImages].filter(Boolean);
      }
      if(mainImages.length) {
        pic = [...pic, ...mainImages].filter(Boolean).slice(0, 5)
        this.updateTbForm({images: pic})
      }
      if(groupMainImages34.length) {
        mainImages34 = [...mainImages34, ...groupMainImages34].filter(Boolean).slice(0, 5)
        this.updateTbForm({threeToFourImages: mainImages34})
      }
      const specificationsRef = this.tbFormVm.$refs.form.$refs.saleProp;
      if(specificationsRef && speImages.length) {
        const firstSpec = specificationsRef[0].specifications[0];
        if (firstSpec && firstSpec.values) {
          firstSpec.values.forEach(specValue => {
            // 如果是新增模式且已有图片，则跳过
            if (type === 'add' && specValue.imageUrl) {
              return;
            }
            
            // 查找匹配的图片
            const matchedImage = speImages.find(img => img.name === specValue.value);
            if (matchedImage) {
              specValue.imageUrl = matchedImage.imgUrl;
            }
          });
        }
      }
    },
    getGroupImagesList(list) {
      this.updateTbForm({showGroupImages: !!list?.length})
    },
    editGroupImages() {
      this.tbFormVm.changeToBase('openGroupImgs');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>